/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */

import genericStyles from "../../Styles/genericStyles.module.css";
import MUIDataTableCustomStyle from "../../Components/MUIDataTableCustomStyle";
import { Vocabulary } from "../../Utils/Vocabulary";
import { useState, createContext } from "react";
import { useNavigate } from "react-router-dom";
import { endpoints, localUrlEnum } from "../../Utils/UrlEnum";
import { ClassModel } from "../../Utils/Models";
import { ETableEditAction, EWidths } from "../../Utils/Enums";
import { FormsIds, TablesIds } from "../../Utils/Constants";
import StandardActionButtons from "../StandarsActionButtons";
import GenericModal from "../GenericModal";
import ClassForm from "./ClassForm";
import { formatDate } from "../../Utils/Utils";
import { AutocompleteChangeReason, Link } from "@mui/material";
import withRole from "../../Hooks/withRole";

export const CRUDContext = createContext(new ClassModel());
function ClassesTable(props: any) {
  const navigate = useNavigate();
  const [contextValue, setContextValue] = useState(new ClassModel());
  const [open, setOpen] = useState(false);
  const [triggerReload, setTriggerReload] = useState<undefined | boolean>();
  const workPointId = props?.restrictByWorkPoint
    ? localStorage.getItem("userWorkPointId")
    : undefined;

  const classesTableColumns = [
    {
      label: ` `,
      name: "_id",
      options: {
        sort: false,
        display: false,
      },
    },
    {
      label: Vocabulary.name,
      name: "name",
      options: {
        sort: false,
        customBodyRender: (name: string, tableMeta: any) => {
          const classId = tableMeta.rowData[0]; // First column should be the _id
          return (
            <Link
              component="button"
              variant="body2"
              onClick={() => navigate(localUrlEnum.classClients.replace(':classId', classId))}
              sx={{ cursor: 'pointer' }}
            >
              {name}
            </Link>
          );
        },
        exportValue: (name: string) => name || "",
      },
    },
    {
      label: Vocabulary.category,
      name: "typeId",
      options: {
        sort: false,
        customBodyRender: (type: any) => {
          return type?.name;
        },
        exportValue: (type: any) => type?.name || "",
      },
    },
    {
      label: Vocabulary.nrOfClientsGraduates,
      name: "nrOfGraduatedClients",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.nrOfClients,
      name: "nrOfTotalClients",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.workPoint,
      name: "workPointId",
      options: {
        sort: false,
        customBodyRender: (object: any) => {
          return object?.name;
        },
        exportValue: (object: any) => object?.name || "",
      },
    },
    {
      label: Vocabulary.createdAt,
      name: "createdAt",
      options: {
        sort: false,
        customBodyRender: (object: any) => {
          return formatDate(object);
        },
        exportValue: (object: any) => object ? formatDate(object) : "",
      },
    },
  ];

  return (
    <div className={genericStyles.mainContainer}>
      <CRUDContext.Provider value={contextValue}>
        <MUIDataTableCustomStyle
          onEditAction={ETableEditAction.MODAL}
          title={Vocabulary.classes}
          columns={classesTableColumns}
          CRUDEndPoint={endpoints.classesEndPoint}
          id={TablesIds.classes}
          setContextValue={setContextValue}
          triggerReload={triggerReload}
          handleModalForm={setOpen}
          filters={
            props?.restrictByWorkPoint && workPointId
              ? { workPointId: workPointId }
              : undefined
          }
          showPrintButton
          showDownloadButton
          exportWithTimestamp
          addOrEditForm={
            <GenericModal
              title={Vocabulary.addNewClass}
              onClose={() => {
                setOpen(false);
                setContextValue(new ClassModel());
              }}
              maxWidth={EWidths.LG}
              open={open}
              actions={
                <StandardActionButtons
                  cancelAction={() => setOpen(false)}
                  okText={Vocabulary.save}
                  cancelText={Vocabulary.cancel}
                  type="submit"
                  formId={FormsIds.classForm}
                />
              }
            >
              <ClassForm
                onClose={() => {
                  setOpen(false);
                  setContextValue(new ClassModel());
                  setTriggerReload(
                    triggerReload !== undefined ? !triggerReload : false
                  );
                }}
                setContextValue={(
                  _e: any,
                  _client: ClassModel | null,
                  _reason: AutocompleteChangeReason,
                  _details?: any
                ) => ({})}
                restrictByWorkPoint={props?.restrictByWorkPoint}
                workPointId={workPointId}
              />
            </GenericModal>
          }
        />
      </CRUDContext.Provider>
    </div>
  );
}

export default withRole(ClassesTable);
